module.exports = __webpack_public_path__ + "img/c9_m.47770447.jpg";